import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=812c2986"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=812c2986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports